{
  "placeholder": "Select…",
  "loading": "Loading…"
}
